// extracted by mini-css-extract-plugin
export default {"orderContainer":"Order_orderContainer__YWr8p"};